var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "LostModuleDashboard"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_vm._m(0), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px !important"
    }
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "form-1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.validateForm('form-1')
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("From Date")]), _vm._v(" "), _c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fromDate),
      expression: "fromDate"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('fromDate')
    },
    staticStyle: {},
    attrs: {
      "id": "fromDate",
      "type": "Date",
      "name": "fromDate",
      "placeholder": "Enter From Date",
      "required": ""
    },
    domProps: {
      "value": (_vm.fromDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fromDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.fromDate')),
      expression: "errors.has('form-1.fromDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select From Date ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("To  Date")]), _vm._v(" "), _c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toDate),
      expression: "toDate"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('toDate')
    },
    attrs: {
      "id": "toDate",
      "type": "Date",
      "name": "toDate",
      "placeholder": "Enter To Date",
      "required": ""
    },
    domProps: {
      "value": (_vm.toDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.toDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.toDate')),
      expression: "errors.has('form-1.toDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select To Date")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', {
    staticClass: "topspace"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v(" "), _c('span', {
    staticClass: "btn btn-sm btn-danger leftmar",
    on: {
      "click": _vm.clear
    }
  }, [_c('i', {
    staticClass: "fa fa-undo ",
    on: {
      "click": _vm.clear
    }
  }), _vm._v(" Reset")])])], 1), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.searchDashboardCount,
      "text": "Please wait data being searching.!"
    },
    on: {
      "update:active": function($event) {
        _vm.searchDashboardCount = $event
      }
    }
  })], 1)])])]), _vm._v(" "), (_vm.searchflag) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("East")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('East', 'ServiceCenter', 'Pending')
      }
    }
  }, [_vm._v(_vm._s(_vm.getServiceCenterDebitsData.East.Pending))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('East', 'ServiceCenter', 'MarkLost')
      }
    }
  }, [_vm._v(_vm._s(_vm.getServiceCenterDebitsData.East.MarkLost))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('East', 'ServiceCenter', 'RMApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getServiceCenterDebitsData.East.RMApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('East', 'ServiceCenter', 'HRApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getServiceCenterDebitsData.East.HRApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('East', 'ServiceCenter', 'FinanceApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getServiceCenterDebitsData.East.FinanceApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link1"
  }, [_vm._v(_vm._s(_vm._f("calculateSum")(_vm.getServiceCenterDebitsData.East)))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("West")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('West', 'ServiceCenter', 'Pending')
      }
    }
  }, [_vm._v(_vm._s(_vm.getServiceCenterDebitsData.West.Pending))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('West', 'ServiceCenter', 'MarkLost')
      }
    }
  }, [_vm._v(_vm._s(_vm.getServiceCenterDebitsData.West.MarkLost))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('West', 'ServiceCenter', 'RMApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getServiceCenterDebitsData.West.RMApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('West', 'ServiceCenter', 'HRApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getServiceCenterDebitsData.West.HRApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('West', 'ServiceCenter', 'FinanceApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getServiceCenterDebitsData.West.FinanceApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link1"
  }, [_vm._v(" " + _vm._s(_vm._f("calculateSum")(_vm.getServiceCenterDebitsData.West)) + " ")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("North")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('North', 'ServiceCenter', 'Pending')
      }
    }
  }, [_vm._v(_vm._s(_vm.getServiceCenterDebitsData.North.Pending))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('North', 'ServiceCenter', 'MarkLost')
      }
    }
  }, [_vm._v(_vm._s(_vm.getServiceCenterDebitsData.North.MarkLost))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('North', 'ServiceCenter', 'RMApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getServiceCenterDebitsData.North.RMApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('North', 'ServiceCenter', 'HRApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getServiceCenterDebitsData.North.HRApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('North', 'ServiceCenter', 'FinanceApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getServiceCenterDebitsData.North.FinanceApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link1"
  }, [_vm._v(" " + _vm._s(_vm._f("calculateSum")(_vm.getServiceCenterDebitsData.North)) + " ")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("South-1")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('South1', 'ServiceCenter', 'Pending')
      }
    }
  }, [_vm._v(_vm._s(_vm.getServiceCenterDebitsData.South1.Pending))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('South1', 'ServiceCenter', 'MarkLost')
      }
    }
  }, [_vm._v(_vm._s(_vm.getServiceCenterDebitsData.South1.MarkLost))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('South1', 'ServiceCenter', 'RMApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getServiceCenterDebitsData.South1.RMApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('South1', 'ServiceCenter', 'HRApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getServiceCenterDebitsData.South1.HRApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('South1', 'ServiceCenter', 'FinanceApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getServiceCenterDebitsData.South1.FinanceApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link1"
  }, [_vm._v(" " + _vm._s(_vm._f("calculateSum")(_vm.getServiceCenterDebitsData.South1)) + " ")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("South-2")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('South2', 'ServiceCenter', 'Pending')
      }
    }
  }, [_vm._v(_vm._s(_vm.getServiceCenterDebitsData.South2.Pending))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('South2', 'ServiceCenter', 'MarkLost')
      }
    }
  }, [_vm._v(_vm._s(_vm.getServiceCenterDebitsData.South2.MarkLost))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('South2', 'ServiceCenter', 'RMApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getServiceCenterDebitsData.South2.RMApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('South2', 'ServiceCenter', 'HRApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getServiceCenterDebitsData.South2.HRApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('South2', 'ServiceCenter', 'FinanceApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getServiceCenterDebitsData.South2.FinanceApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link1"
  }, [_vm._v(" " + _vm._s(_vm._f("calculateSum")(_vm.getServiceCenterDebitsData.South2)) + " ")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Central")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('Central', 'ServiceCenter', 'Pending')
      }
    }
  }, [_vm._v(_vm._s(_vm.getServiceCenterDebitsData.Central.Pending))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('Central', 'ServiceCenter', 'MarkLost')
      }
    }
  }, [_vm._v(_vm._s(_vm.getServiceCenterDebitsData.Central.MarkLost))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('Central', 'ServiceCenter', 'RMApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getServiceCenterDebitsData.Central.RMApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('Central', 'ServiceCenter', 'HRApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getServiceCenterDebitsData.Central.HRApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('Central', 'ServiceCenter', 'FinanceApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getServiceCenterDebitsData.Central.FinanceApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link1"
  }, [_vm._v(_vm._s(_vm._f("calculateSum")(_vm.getServiceCenterDebitsData.Central)) + " ")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("North East")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('NorthEast', 'ServiceCenter', 'Pending')
      }
    }
  }, [_vm._v(_vm._s(_vm.getServiceCenterDebitsData.NorthEast.Pending))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('NorthEast', 'ServiceCenter', 'MarkLost')
      }
    }
  }, [_vm._v(_vm._s(_vm.getServiceCenterDebitsData.NorthEast.MarkLost))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('NorthEast', 'ServiceCenter', 'RMApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getServiceCenterDebitsData.NorthEast.RMApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('NorthEast', 'ServiceCenter', 'HRApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getServiceCenterDebitsData.NorthEast.HRApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('NorthEast', 'ServiceCenter', 'FinanceApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getServiceCenterDebitsData.NorthEast.FinanceApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link1"
  }, [_vm._v(_vm._s(_vm._f("calculateSum")(_vm.getServiceCenterDebitsData.NorthEast)) + "  ")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Total")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('Total', 'ServiceCenter', 'Pending')
      }
    }
  }, [_vm._v(_vm._s(_vm.getServiceCenterDebitsData.Total.PendingDebitsTotal))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('Total', 'ServiceCenter', 'MarkLost')
      }
    }
  }, [_vm._v(_vm._s(_vm.getServiceCenterDebitsData.Total.PendingMarkLostTotal))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('Total', 'ServiceCenter', 'RMApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getServiceCenterDebitsData.Total.PendingRMApprovalTotal))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('Total', 'ServiceCenter', 'HRApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getServiceCenterDebitsData.Total.PendingHRApprovalTotal))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('Total', 'ServiceCenter', 'FinanceApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getServiceCenterDebitsData.Total.PendingFinanceApprovalTotal))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link1"
  }, [_vm._v(_vm._s(_vm.getServiceCenterDebitsData.Total.PendingMarkLostTotal + _vm.getServiceCenterDebitsData.Total.PendingDebitsTotal +
    _vm.getServiceCenterDebitsData.Total.PendingRMApprovalTotal + _vm.getServiceCenterDebitsData.Total.PendingHRApprovalTotal + _vm.getServiceCenterDebitsData.Total.PendingFinanceApprovalTotal))])])])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_vm._m(3), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(4), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("East")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('East', 'LineHaul', 'Pending')
      }
    }
  }, [_vm._v(_vm._s(_vm.getLineHaulDebitsData.East.Pending))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('East', 'LineHaul', 'MarkLost')
      }
    }
  }, [_vm._v(_vm._s(_vm.getLineHaulDebitsData.East.MarkLost))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('East', 'LineHaul', 'RMApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getLineHaulDebitsData.East.RMApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('East', 'LineHaul', 'transitApproved')
      }
    }
  }, [_vm._v(_vm._s(_vm.getLineHaulDebitsData.East.transitApproved))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('East', 'LineHaul', 'FinanceApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getLineHaulDebitsData.East.FinanceApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link1"
  }, [_vm._v(_vm._s(_vm._f("calculateSumForLinehual")(_vm.getLineHaulDebitsData.East)))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("West")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('West', 'LineHaul', 'Pending')
      }
    }
  }, [_vm._v(_vm._s(_vm.getLineHaulDebitsData.West.Pending))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('West', 'LineHaul', 'MarkLost')
      }
    }
  }, [_vm._v(_vm._s(_vm.getLineHaulDebitsData.West.MarkLost))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('West', 'LineHaul', 'RMApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getLineHaulDebitsData.West.RMApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('West', 'LineHaul', 'transitApproved')
      }
    }
  }, [_vm._v(_vm._s(_vm.getLineHaulDebitsData.West.transitApproved))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('West', 'LineHaul', 'FinanceApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getLineHaulDebitsData.West.FinanceApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link1"
  }, [_vm._v(_vm._s(_vm._f("calculateSumForLinehual")(_vm.getLineHaulDebitsData.West)))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("North")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('North', 'LineHaul', 'Pending')
      }
    }
  }, [_vm._v(_vm._s(_vm.getLineHaulDebitsData.North.Pending))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('North', 'LineHaul', 'MarkLost')
      }
    }
  }, [_vm._v(_vm._s(_vm.getLineHaulDebitsData.North.MarkLost))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('North', 'LineHaul', 'RMApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getLineHaulDebitsData.North.RMApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('North', 'LineHaul', 'transitApproved')
      }
    }
  }, [_vm._v(_vm._s(_vm.getLineHaulDebitsData.North.transitApproved))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('North', 'LineHaul', 'FinanceApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getLineHaulDebitsData.North.FinanceApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link1"
  }, [_vm._v(_vm._s(_vm._f("calculateSumForLinehual")(_vm.getLineHaulDebitsData.North)))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("South-1")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('South1', 'LineHaul', 'Pending')
      }
    }
  }, [_vm._v(_vm._s(_vm.getLineHaulDebitsData.South1.Pending))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('South1', 'LineHaul', 'MarkLost')
      }
    }
  }, [_vm._v(_vm._s(_vm.getLineHaulDebitsData.South1.MarkLost))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('South1', 'LineHaul', 'RMApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getLineHaulDebitsData.South1.RMApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('South1', 'LineHaul', 'transitApproved')
      }
    }
  }, [_vm._v(_vm._s(_vm.getLineHaulDebitsData.South1.transitApproved))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('South1', 'LineHaul', 'FinanceApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getLineHaulDebitsData.South1.FinanceApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link1"
  }, [_vm._v(_vm._s(_vm._f("calculateSumForLinehual")(_vm.getLineHaulDebitsData.South1)))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("South-2")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('South2', 'LineHaul', 'Pending')
      }
    }
  }, [_vm._v(_vm._s(_vm.getLineHaulDebitsData.South2.Pending))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('South2', 'LineHaul', 'MarkLost')
      }
    }
  }, [_vm._v(_vm._s(_vm.getLineHaulDebitsData.South2.MarkLost))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('South2', 'LineHaul', 'RMApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getLineHaulDebitsData.South2.RMApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('South2', 'LineHaul', 'transitApproved')
      }
    }
  }, [_vm._v(_vm._s(_vm.getLineHaulDebitsData.South2.transitApproved))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('South2', 'LineHaul', 'FinanceApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getLineHaulDebitsData.South2.FinanceApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link1"
  }, [_vm._v(_vm._s(_vm._f("calculateSumForLinehual")(_vm.getLineHaulDebitsData.South2)))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Central")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('Central', 'LineHaul', 'Pending')
      }
    }
  }, [_vm._v(_vm._s(_vm.getLineHaulDebitsData.Central.Pending))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('Central', 'LineHaul', 'MarkLost')
      }
    }
  }, [_vm._v(_vm._s(_vm.getLineHaulDebitsData.Central.MarkLost))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('Central', 'LineHaul', 'RMApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getLineHaulDebitsData.Central.RMApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('Central', 'LineHaul', 'transitApproved')
      }
    }
  }, [_vm._v(_vm._s(_vm.getLineHaulDebitsData.Central.transitApproved))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('Central', 'LineHaul', 'FinanceApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getLineHaulDebitsData.Central.FinanceApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link1"
  }, [_vm._v(_vm._s(_vm._f("calculateSumForLinehual")(_vm.getLineHaulDebitsData.Central)))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("North East")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('NorthEast', 'LineHaul', 'Pending')
      }
    }
  }, [_vm._v(_vm._s(_vm.getLineHaulDebitsData.NorthEast.Pending))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('NorthEast', 'LineHaul', 'MarkLost')
      }
    }
  }, [_vm._v(_vm._s(_vm.getLineHaulDebitsData.NorthEast.MarkLost))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('NorthEast', 'LineHaul', 'RMApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getLineHaulDebitsData.NorthEast.RMApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('NorthEast', 'LineHaul', 'transitApproved')
      }
    }
  }, [_vm._v(_vm._s(_vm.getLineHaulDebitsData.NorthEast.transitApproved))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('NorthEast', 'LineHaul', 'FinanceApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getLineHaulDebitsData.NorthEast.FinanceApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link1"
  }, [_vm._v(_vm._s(_vm._f("calculateSumForLinehual")(_vm.getLineHaulDebitsData.NorthEast)))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Total")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('Total', 'LineHaul', 'Pending')
      }
    }
  }, [_vm._v(_vm._s(_vm.getLineHaulDebitsData.Total.PendingDebitsTotal))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('Total', 'LineHaul', 'MarkLost')
      }
    }
  }, [_vm._v(_vm._s(_vm.getLineHaulDebitsData.Total.PendingMarkLostTotal))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('Total', 'LineHaul', 'RMApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getLineHaulDebitsData.Total.PendingRMApprovalTotal))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('Total', 'LineHaul', 'transitApproved')
      }
    }
  }, [_vm._v(_vm._s(_vm.getLineHaulDebitsData.Total.PendingtransitApprovedTotal))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('Total', 'LineHaul', 'FinanceApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getLineHaulDebitsData.Total.PendingFinanceApprovalTotal))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link1"
  }, [_vm._v(_vm._s(_vm.getLineHaulDebitsData.Total.PendingMarkLostTotal + _vm.getLineHaulDebitsData.Total.PendingDebitsTotal +
    _vm.getLineHaulDebitsData.Total.PendingRMApprovalTotal + _vm.getLineHaulDebitsData.Total.PendingtransitApprovedTotal + _vm.getLineHaulDebitsData.Total.PendingFinanceApprovalTotal))])])])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_vm._m(5), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(6), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("East")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('East', 'Vendor', 'Pending')
      }
    }
  }, [_vm._v(_vm._s(_vm.getVehicleVendorDebitsData.East.Pending))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('East', 'Vendor', 'MarkLost')
      }
    }
  }, [_vm._v(_vm._s(_vm.getVehicleVendorDebitsData.East.MarkLost))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('East', 'Vendor', 'RMApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getVehicleVendorDebitsData.East.RMApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('East', 'Vendor', 'FinanceApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getVehicleVendorDebitsData.East.FinanceApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link1"
  }, [_vm._v(_vm._s(_vm._f("calculateSumForVendor")(_vm.getVehicleVendorDebitsData.East)))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("West")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('West', 'Vendor', 'Pending')
      }
    }
  }, [_vm._v(_vm._s(_vm.getVehicleVendorDebitsData.West.Pending))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('West', 'Vendor', 'MarkLost')
      }
    }
  }, [_vm._v(_vm._s(_vm.getVehicleVendorDebitsData.West.MarkLost))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('West', 'Vendor', 'RMApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getVehicleVendorDebitsData.West.RMApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('West', 'Vendor', 'FinanceApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getVehicleVendorDebitsData.West.FinanceApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link1"
  }, [_vm._v(_vm._s(_vm._f("calculateSumForVendor")(_vm.getVehicleVendorDebitsData.West)))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("North")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('North', 'Vendor', 'Pending')
      }
    }
  }, [_vm._v(_vm._s(_vm.getVehicleVendorDebitsData.North.Pending))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "linSouth1k",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('North', 'Vendor', 'MarkLost')
      }
    }
  }, [_vm._v(_vm._s(_vm.getVehicleVendorDebitsData.North.MarkLost))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('North', 'Vendor', 'RMApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getVehicleVendorDebitsData.North.RMApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('North', 'Vendor', 'FinanceApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getVehicleVendorDebitsData.North.FinanceApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link1"
  }, [_vm._v(_vm._s(_vm._f("calculateSumForVendor")(_vm.getVehicleVendorDebitsData.North)))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("South-1")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('South1', 'Vendor', 'Pending')
      }
    }
  }, [_vm._v(_vm._s(_vm.getVehicleVendorDebitsData.South1.Pending))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('South1', 'Vendor', 'MarkLost')
      }
    }
  }, [_vm._v(_vm._s(_vm.getVehicleVendorDebitsData.South1.MarkLost))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('South1', 'Vendor', 'RMApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getVehicleVendorDebitsData.South1.RMApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('South1', 'Vendor', 'FinanceApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getVehicleVendorDebitsData.South1.FinanceApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link1"
  }, [_vm._v(_vm._s(_vm._f("calculateSumForVendor")(_vm.getVehicleVendorDebitsData.South1)))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("South-2")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('South2', 'Vendor', 'Pending')
      }
    }
  }, [_vm._v(_vm._s(_vm.getVehicleVendorDebitsData.South2.Pending))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('South2', 'Vendor', 'MarkLost')
      }
    }
  }, [_vm._v(_vm._s(_vm.getVehicleVendorDebitsData.South2.MarkLost))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('South2', 'Vendor', 'RMApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getVehicleVendorDebitsData.South2.RMApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('South2', 'Vendor', 'FinanceApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getVehicleVendorDebitsData.South2.FinanceApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link1"
  }, [_vm._v(_vm._s(_vm._f("calculateSumForVendor")(_vm.getVehicleVendorDebitsData.South2)))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Central")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('Central', 'Vendor', 'Pending')
      }
    }
  }, [_vm._v(_vm._s(_vm.getVehicleVendorDebitsData.Central.Pending))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('Central', 'Vendor', 'MarkLost')
      }
    }
  }, [_vm._v(_vm._s(_vm.getVehicleVendorDebitsData.Central.MarkLost))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('Central', 'Vendor', 'RMApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getVehicleVendorDebitsData.Central.RMApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('Central', 'Vendor', 'FinanceApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getVehicleVendorDebitsData.Central.FinanceApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link1"
  }, [_vm._v(_vm._s(_vm._f("calculateSumForVendor")(_vm.getVehicleVendorDebitsData.Central)))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("North East")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('NorthEast', 'Vendor', 'Pending')
      }
    }
  }, [_vm._v(_vm._s(_vm.getVehicleVendorDebitsData.NorthEast.Pending))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('NorthEast', 'Vendor', 'MarkLost')
      }
    }
  }, [_vm._v(_vm._s(_vm.getVehicleVendorDebitsData.NorthEast.MarkLost))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('NorthEast', 'Vendor', 'RMApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getVehicleVendorDebitsData.NorthEast.RMApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('NorthEast', 'Vendor', 'FinanceApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getVehicleVendorDebitsData.NorthEast.FinanceApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link1"
  }, [_vm._v(_vm._s(_vm._f("calculateSumForVendor")(_vm.getVehicleVendorDebitsData.NorthEast)))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Total")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('Total', 'Vendor', 'Pending')
      }
    }
  }, [_vm._v(_vm._s(_vm.getVehicleVendorDebitsData.Total.PendingDebitsTotal))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('Total', 'Vendor', 'MarkLost')
      }
    }
  }, [_vm._v(_vm._s(_vm.getVehicleVendorDebitsData.Total.PendingMarkLostTotal))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('Total', 'Vendor', 'RMApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getVehicleVendorDebitsData.Total.PendingRMApprovalTotal))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('Total', 'Vendor', 'FinanceApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getVehicleVendorDebitsData.Total.PendingFinanceApprovalTotal))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link1"
  }, [_vm._v(_vm._s(_vm.getVehicleVendorDebitsData.Total.PendingMarkLostTotal + _vm.getVehicleVendorDebitsData.Total.PendingDebitsTotal +
    _vm.getVehicleVendorDebitsData.Total.PendingRMApprovalTotal + _vm.getVehicleVendorDebitsData.Total.PendingFinanceApprovalTotal))])])])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_vm._m(7), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(8), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("East")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('East', 'SuperAgent', 'RMApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getSuperAgentDebitsData.East.RMApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('East', 'SuperAgent', 'HRApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getSuperAgentDebitsData.East.HRApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('East', 'SuperAgent', 'FinanceApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getSuperAgentDebitsData.East.FinanceApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link1"
  }, [_vm._v(_vm._s(_vm._f("calculateSumForSuperAgent")(_vm.getSuperAgentDebitsData.East)))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("West")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('West', 'SuperAgent', 'RMApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getSuperAgentDebitsData.West.RMApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('West', 'SuperAgent', 'HRApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getSuperAgentDebitsData.West.HRApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('West', 'SuperAgent', 'FinanceApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getSuperAgentDebitsData.West.FinanceApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link1"
  }, [_vm._v(_vm._s(_vm._f("calculateSumForSuperAgent")(_vm.getSuperAgentDebitsData.West)))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("North")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('North', 'SuperAgent', 'RMApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getSuperAgentDebitsData.North.RMApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('North', 'SuperAgent', 'HRApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getSuperAgentDebitsData.North.HRApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('North', 'SuperAgent', 'FinanceApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getSuperAgentDebitsData.North.FinanceApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link1"
  }, [_vm._v(_vm._s(_vm._f("calculateSumForSuperAgent")(_vm.getSuperAgentDebitsData.North)))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("South - 1")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('South1', 'SuperAgent', 'RMApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getSuperAgentDebitsData.South1.RMApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('South1', 'SuperAgent', 'HRApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getSuperAgentDebitsData.South1.HRApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('South1', 'SuperAgent', 'FinanceApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getSuperAgentDebitsData.South1.FinanceApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link1"
  }, [_vm._v(_vm._s(_vm._f("calculateSumForSuperAgent")(_vm.getSuperAgentDebitsData.South1)))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("South - 2")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('South2', 'SuperAgent', 'RMApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getSuperAgentDebitsData.South2.RMApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('South2', 'SuperAgent', 'HRApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getSuperAgentDebitsData.South2.HRApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('South2', 'SuperAgent', 'FinanceApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getSuperAgentDebitsData.South2.FinanceApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link1"
  }, [_vm._v(_vm._s(_vm._f("calculateSumForSuperAgent")(_vm.getSuperAgentDebitsData.South2)))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Central")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('Central', 'SuperAgent', 'RMApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getSuperAgentDebitsData.Central.RMApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('Central', 'SuperAgent', 'HRApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getSuperAgentDebitsData.Central.HRApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('Central', 'SuperAgent', 'FinanceApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getSuperAgentDebitsData.Central.FinanceApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link1"
  }, [_vm._v(_vm._s(_vm._f("calculateSumForSuperAgent")(_vm.getSuperAgentDebitsData.Central)))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("North East")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('NorthEast', 'SuperAgent', 'RMApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getSuperAgentDebitsData.NorthEast.RMApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('NorthEast', 'SuperAgent', 'HRApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getSuperAgentDebitsData.NorthEast.HRApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('NorthEast', 'SuperAgent', 'FinanceApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getSuperAgentDebitsData.NorthEast.FinanceApprove))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link1"
  }, [_vm._v(_vm._s(_vm._f("calculateSumForSuperAgent")(_vm.getSuperAgentDebitsData.NorthEast)))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Total")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('Total', 'SuperAgent', 'RMApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getSuperAgentDebitsData.Total.PendingRMApprovalTotal))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('Total', 'SuperAgent', 'HRApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getSuperAgentDebitsData.Total.PendingHRApprovalTotal))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.getLostShipmetsDetails('Total', 'SuperAgent', 'FinanceApprove')
      }
    }
  }, [_vm._v(_vm._s(_vm.getSuperAgentDebitsData.Total.PendingFinanceApprovalTotal))])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "link1"
  }, [_vm._v(_vm._s(_vm.getSuperAgentDebitsData.Total.PendingRMApprovalTotal + _vm.getSuperAgentDebitsData.Total.PendingHRApprovalTotal +
    _vm.getSuperAgentDebitsData.Total.PendingFinanceApprovalTotal))])])])])]), _c('br')])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getLostShipmetsDetailsflag == true),
      expression: "getLostShipmetsDetailsflag==true"
    }],
    staticClass: "row",
    attrs: {
      "id": "shipmentDetails"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.searchShipmentSummary,
      "text": "Please wait data being searching.!"
    },
    on: {
      "update:active": function($event) {
        _vm.searchShipmentSummary = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_vm._m(9), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(10), _vm._v(" "), _c('tbody', [(_vm.getServiceCenterDebitsData.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "9",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getLostShipmetsDetailsData), function(val) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(val.PendingDays))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.ShippingID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.Status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("changeDateFormat")(val.CreatedDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.Comments))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.OctroiMRP))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("setDebitAmount")(val)))]), _vm._v(" "), _c('td', {}, [_c('span', {
      staticClass: "link",
      on: {
        "click": function($event) {
          _vm.getShipmentAttachmentPopup(val.ShippingID)
        }
      }
    }, [_vm._v("View Image")])])])
  })], 2)]), _c('br'), _vm._v(" "), _c('paginate', {
    ref: "paginate",
    attrs: {
      "page-count": _vm.pagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "modal-dialog modal-lg"
    },
    on: {
      "ok": function($event) {
        _vm.getAttachmentFlag = false
      }
    },
    model: {
      value: (_vm.getAttachmentFlag),
      callback: function($$v) {
        _vm.getAttachmentFlag = $$v
      },
      expression: "getAttachmentFlag"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.attachmentLoader
    },
    on: {
      "update:active": function($event) {
        _vm.attachmentLoader = $event
      }
    }
  }), _vm._v(" "), _c('b-card', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Attachment ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeAttachmentPopup
    }
  }, [_vm._v("x")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 lg-auto"
  }, [_c('table', {
    staticClass: "PopupraiseRMDebitNoteEditTable",
    attrs: {
      "cellpadding": "5px",
      "cellspacing": "5px"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("Attachment")])])]), _vm._v(" "), _c('tbody', [(_vm.getAttachmentListData.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "align": "center"
    }
  }, [_vm._v("No Attachments Available.! ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getAttachmentListData), function(val, index) {
    return _c('tr', [_c('td', [_vm._v(" " + _vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": val.filePath,
        "target": "_blank",
        "title": val.fileName
      }
    }, [_vm._v(" " + _vm._s(val.fileName))])])])
  })], 2)])])])])], 1)], 1)], 1)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('legend', [_vm._v("Lost Module Dashboard")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Service Center Debits")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Region")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Pending Mark Lost")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Pending Debits")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Pending RM Approval")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Pending HR Approval")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Pending Finance Approval")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Total")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" LineHaul Debits")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Region")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Pending Mark Lost")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Pending Debits")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Pending RM Approval")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Pending Transit Approval")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Pending Finance Approval")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Total")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Vehicle Vendor Debits")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Region")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Pending Mark Lost")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Pending Debits")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Pending RM Approval")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Pending Finance Approval")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Total")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Super Agent Debits")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Region")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Pending RM Approval")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Pending HR Approval")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Pending Finance Approval")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Total")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Details")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Pending Days")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("AWB Number")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Debit Bucket")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Created Date\t")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Comments")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Octroi MRP")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Debit Amount")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Doc Link")])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7317e2b4","hasScoped":true}!./src/views/components/LOST/LostModuleDashboard/LostModuleDashboard.component.html
// module id = 997
// module chunks = 1